import { render } from "./NpsComponent.vue?vue&type=template&id=7c1c8868&scoped=true&ts=true"
import script from "./NpsComponent.vue?vue&type=script&lang=ts"
export * from "./NpsComponent.vue?vue&type=script&lang=ts"

import "./NpsComponent.vue?vue&type=style&index=0&id=7c1c8868&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1c8868"]])

export default __exports__